// ======= imported  all products images from images folder ========
import pizzaImg01 from '../images/pizza1.png';

import fastFood03 from '../images/chicken3.png';
import fastFood04 from '../images/chicken4.png';

import dessert02 from '../images/dessert02.png';
import dessert03 from '../images/dessert2.png';
import dessert04 from '../images/dessert3.png';

import coffeeImg02 from '../images/coffe2.png';

import salad from '../images/slider2.png';

export const popularMenuFood = [
    {
        id: '01',
        title: 'Vegetable Salad',
        price: 25,
        imgUrl: fastFood03,
    },
    {
        id: '02',
        title: 'Chicken',
        price: 250,
        imgUrl: fastFood04,
    },

    {
        id: '03',
        title: 'Chum Salmon',
        price: 45,
        imgUrl: dessert02,
    },

    {
        id: '04',
        title: 'Pizza',
        price: 75,
        imgUrl: pizzaImg01,
    },
];

export const fastFoodProducts = [
    {
        id: '05',
        title: 'Burger',
        price: 95,
        imgUrl: fastFood04,
    },
    {
        id: '06',
        title: 'Chicken',
        price: 250,
        imgUrl: fastFood04,
    },
    {
        id: '07',
        title: 'Grill Chicken',
        price: 195,
        imgUrl: fastFood04,
    },
    {
        id: '08',
        title: 'Barbeque',
        price: 275,
        imgUrl: fastFood04,
    },
    {
        id: '09',
        title: 'Pizza',
        price: 275,
        imgUrl: fastFood04,
    },
    {
        id: '10',
        title: 'Burger',
        price: 95,
        imgUrl: fastFood04,
    },
    {
        id: '11',
        title: 'Chicken',
        price: 250,
        imgUrl: fastFood04,
    },
    {
        id: '12',
        title: 'Grill Chicken',
        price: 195,
        imgUrl: fastFood04,
    },
];

export const riceMenuProducts = [
    {
        id: '12',
        title: 'Fried Rice',
        price: 95,
        imgUrl: salad,
    },
    {
        id: '14',
        title: 'Vegetable',
        price: 250,
        imgUrl: salad,
    },
    {
        id: '15',
        title: 'Vegetable Salad',
        price: 195,
        imgUrl: salad,
    },
    {
        id: '16',
        title: 'Meal',
        price: 275,
        imgUrl: salad,
    },
    {
        id: '17',
        title: 'Fried Rice',
        price: 95,
        imgUrl: salad,
    },
    {
        id: '18',
        title: 'Vegetable',
        price: 250,
        imgUrl: salad,
    },
    {
        id: '19',
        title: 'Vegetable Salad',
        price: 195,
        imgUrl: salad,
    },
    {
        id: '20',
        title: 'Meal',
        price: 275,
        imgUrl: salad,
    },
];

export const dessertProducts = [
    {
        id: '21',
        title: 'Whipped Cream',
        price: 50,
        imgUrl: dessert03,
    },
    {
        id: '22',
        title: 'Cake Cream',
        price: 50,
        imgUrl: dessert02,
    },
    {
        id: '23',
        title: 'Cake',
        price: 50,
        imgUrl: dessert03,
    },
    {
        id: '24',
        title: 'Cup Cake',
        price: 275,
        imgUrl: dessert04,
    },
    {
        id: '25',
        title: 'Whipped Cream',
        price: 50,
        imgUrl: dessert03,
    },
    {
        id: '26',
        title: 'Cake Cream',
        price: 50,
        imgUrl: dessert02,
    },
    {
        id: '27',
        title: 'Cake',
        price: 50,
        imgUrl: dessert03,
    },
    {
        id: '28',
        title: 'Cup Cake',
        price: 275,
        imgUrl: dessert04,
    },
];

export const pizzaProducts = [
    {
        id: '29',
        title: 'Pizza',
        price: 95,
        imgUrl: pizzaImg01,
    },
    {
        id: '30',
        title: 'Pizza',
        price: 95,
        imgUrl: pizzaImg01,
    },
    {
        id: '31',
        title: 'Pizza',
        price: 95,
        imgUrl: pizzaImg01,
    },
    {
        id: '32',
        title: 'Pizza',
        price: 95,
        imgUrl: pizzaImg01,
    },
    {
        id: '33',
        title: 'Pizza',
        price: 95,
        imgUrl: pizzaImg01,
    },
    {
        id: '34',
        title: 'Pizza',
        price: 95,
        imgUrl: pizzaImg01,
    },

    {
        id: '35',
        title: 'Pizza',
        price: 95,
        imgUrl: pizzaImg01,
    },
    {
        id: '36',
        title: 'Pizza',
        price: 95,
        imgUrl: pizzaImg01,
    },
];

export const coffeeProducts = [
    {
        id: '37',
        title: 'Hot Coffee',
        price: 20,
        imgUrl: coffeeImg02,
    },
    {
        id: '38',
        title: 'Cold Coffee',
        price: 20,
        imgUrl: coffeeImg02,
    },
    {
        id: '39',
        title: 'Black Coffee',
        price: 20,
        imgUrl: coffeeImg02,
    },
    {
        id: '40',
        title: 'White Coffee',
        price: 95,
        imgUrl: coffeeImg02,
    },
    {
        id: '41',
        title: 'Hot Coffee',
        price: 20,
        imgUrl: coffeeImg02,
    },
    {
        id: '42',
        title: 'Cold Coffee',
        price: 20,
        imgUrl: coffeeImg02,
    },

    {
        id: '43',
        title: 'Black Coffee',
        price: 20,
        imgUrl: coffeeImg02,
    },
    {
        id: '44',
        title: 'White Coffee',
        price: 95,
        imgUrl: coffeeImg02,
    },
];
